import './login.css'

function Login() {
  return (
    <>
    <section className="blog spad">
    <div className="container">
    <div className="row">
        <div className="col-lg-6 col-md-6">
            <div className="contact__content">
                <div className="contact__form text-center login">
                    <h5>Login with </h5>                       
                  <div className="footer__social icons">
                  <a href="#">
                    <i className="fa fa-facebook"></i>
                  </a>
                  <a href="#">
                    <i className="fa fa-google"></i>
                  </a>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </div>
                            <hr />
                    <p className='text-center'>or</p>  
                    {/* <h5>Login</h5> */}
                    <form action="#" className='login-form'>
                        <input type="text" className='effect-input'  placeholder="Email"/>
                        <input type="password" placeholder="Password"/>
                        <p className='text-right fg'>Forget Password</p>
                        <button type="submit" className="site-btn">Login</button>
                    </form>
                </div>
            </div>
        </div>
        <div className="col-lg-6 col-md-6">
        <div className="contact__form text-center login">
                    <h5>Register with</h5>
                    <div className="footer__social icons">
                  <a href="#">
                    <i className="fa fa-facebook"></i>
                  </a>
                  <a href="#">
                    <i className="fa fa-google"></i>
                  </a>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </div>
                            {/* <div class="vr"></div> */}
                    <p className='text-center mt-3'>or</p>
                    <form action="#" className='login-form'>
                        <input type="text" placeholder="Name"/>
                        <input type="text" placeholder="Email"/>
                        <input type="password" placeholder="password"/>
                        <button type="submit" className="site-btn">Register</button>
                    </form>
                </div>
    </div>
</div>
</div>
</section>
</>
  )
}

export default Login